import {useBookingSummary} from 'presentation/modules/booking/shared/hooks/useBookingSummary';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useMediaQueries, useQueryParams} from 'presentation/pages';
import {HealthUnitsAccreditedNetworkProps} from '../../types';
import {useReverseNetworkOrder} from 'presentation/hooks/useReverseNetworkOrder';

export function useHealthUnitsAccreditedNetwork({unitsList}: HealthUnitsAccreditedNetworkProps) {
	const {isMobile} = useMediaQueries();
	const {handleChangeModals} = useBookingSummary();
	const {specialtyName} = useBookingStore(state => state.bookingData);
	const {shouldReverseNetworkOrder} = useReverseNetworkOrder({flowType: 'HEALTH'});
	const {
		SEARCH_PARAMS: {query},
	} = useQueryParams();

	const listIsEmpty = unitsList.length === 0;

	return {
		listIsEmpty,
		isMobile,
		handleChangeModals,
		specialtyName,
		query,
		shouldReverseNetworkOrder,
	};
}
